// React
import { useCallback, useState } from 'react'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { LIMITS } from '@weblite/permission'
// Common
import { PageWithAppBar } from '$common/page-with-app-bar'
import { SettingsSection } from '$common/settings-section'
import { AppBarBackTitleConfirm } from '$common/app-bar/app-bar-back-title-confirm'
import { MultilineInput } from '$common/input'
import { updateClientUser } from '$logic/client-user'
import { closeEditBio } from '$logic/router'
import { showDiscardChangesConfirmModal } from '$comp/modals/confirmation-dialog'
import { useClientUser } from '$logic/client-user/react-hook'
// Localization
import { t } from '$i18n'
import { areEqualStr } from '$func/text'
import { showSaveChangesLoadingModal } from '$comp/modals/loading-modal'

const { userConstraints } = LIMITS

export function EditBio() {
  const user = useClientUser()
  const [bio, setBio] = useState(user.bio || '')

  const valueChanged = !areEqualStr(bio, user.bio || '')

  const onConfirm = useCallback(async () => {
    if (valueChanged) {
      // TODO: Verify value
      showSaveChangesLoadingModal()
      await updateClientUser({ bio })
      await closeCurrentModal()
      closeEditBio()
    }
  }, [bio, valueChanged])

  const onBack = useCallback(() => {
    if (valueChanged) showDiscardChangesConfirmModal(closeEditBio, onConfirm)
    else closeEditBio()
  }, [onConfirm, valueChanged])

  return (
    <PageWithAppBar
      appBar={
        <AppBarBackTitleConfirm
          title={t('user.bio')}
          confirmDisabled={!valueChanged}
          onBack={onBack}
          onConfirm={onConfirm}
        />
      }
    >
      <SettingsSection sx={{ padding: '14px 20px 20px' }}>
        <MultilineInput
          autoFocus
          maxLength={userConstraints.bio.maxLength}
          value={bio}
          onChange={setBio}
          showMaxLength
        />
      </SettingsSection>
    </PageWithAppBar>
  )
}
